import { html } from 'lit';
import { Minimize2 } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-minimize')
export class PdsIconMinimize extends PdsIcon {
  @state()
  icon = Minimize2;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
